// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cw_a bhc_rl","ProductBuyerHeader__username":"cw_b bhc_ua"};